/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { HttpEventType } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { DownloadDialogComponent } from "src/app/features/liveshop/download-dialog/download-dialog.component";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { ReportsService } from "src/app/services/reports/reports.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { Injectable } from "@angular/core";
import { cloneDeep } from "lodash-es";

@Injectable({
  providedIn: "root",
})
export class ProgressbarService {
  progress = 0;
  progressBar;
  canShowLoad = true;
  i = -1;
  constructor(
    public toastrService: ToastrService,
    public slotService: SlotService,
    public dialog: MatDialog,
    public reportsService: ReportsService,
    public dialogService: DialogService
  ) {}
  startDownload(getlist, filename, i, format?) {
    getlist.subscribe(
      (event: any) => {
        if (event.type === HttpEventType.DownloadProgress) {
          if (this.i === i) {
            this.progress = Math.round((100 / event.total) * event.loaded);
            this.slotService.progressReport = this.progress;
          }
        } else if (event.type === HttpEventType.Response) {
          console.log("event download");
          this.reportsService.downloadFile(event.body, filename, format);
          if (this.i === i) {
            this.progressBar.close();
            this.slotService.progressReport = 0;
          }
        }
      },
      (err) => {
        const error = JSON.parse(
          String.fromCharCode.apply(null, new Uint8Array(err.error))
        )?.message;
        this.toastrService.error(error ? error : "Download failed", null, {
          timeOut: 2000,
        });
        this.progressBar.close();
        this.slotService.progressReport = 0;
      }
    );
  }
  DownloadwithProgressbar(getlist, filename, format?) {
    const progress = 0;
    this.i = this.i + 1;
    const i = this.i;
    this.progressBar = this.dialogService.openMatDialog(
      DownloadDialogComponent,
      { progress: progress, isdisableClose: true },
      true
    );
    this.slotService.progressReport = 0;
    this.startDownload(getlist, filename, i, format);

    this.progressBar.afterClosed().subscribe(() => {
      this.progress = 0;
      this.slotService.progressReport = 0;
    });
  }
}
